import React, { useEffect, useState } from "react";
import DataTableServerSidePagination from "../components/dataTableServerSidepagination/DataTableServerSidePagination.tsx";
import axios from "axios";
import "./Orders.css";
import pendingDot from "./../../assets/icons/pendingdot.png";
import approvegDot from "./../../assets/icons/approvedDot.png";
import rejectDot from "./../../assets/icons/cancelDot.png";
import queue from "./../../assets/icons/queue.png";
import readyDot from "./../../assets/icons/readyDot.png";
import all from "./../../assets/icons/select-all.png";
import deliveredDot from "./../../assets/icons/delivered.png";
import kitchen from "./../../assets/icons/kitchen.png";
import order from "./../../assets/icons/order.png";
import TopHeader from "../../components/TopHeader.tsx";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import StatusButton from "./components/StatusButton.tsx";
import ItemsDialog from "./components/ItemsDialog.tsx";
import DateFormatter from "../components/DateFormatter/DateFormatter.tsx";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import KitchenSetupPage from "../restaurantsetup/components/KitchenSetupPage/KitchenSetupPage.tsx";
import { useSelector, useDispatch } from "react-redux";
import { setBooleanValue } from "../../reduxadmin/Reducers/dataHasBeenChanged.js";
import { DataGrid } from "@mui/x-data-grid";
import jwtDecode from "jwt-decode";
import {
  setupNotification,
  unregisterPush,
} from "../../services/PwaService.tsx";

function Orders() {
  const apiAddress = process.env.REACT_APP_SECRET;
  const restaurant = localStorage.getItem("restaurant");
  const [OrderStatusList, setOrderStatusLIst] = useState([]);
  const [SelectedOrderIds, setSelectedOrderIds] = useState([]);
  const [OrderList, setOrderList] = useState([]);
  const [akgisLoading, SetakgIsLoading] = useState(false);
  const [akgrows, setAkgrows] = useState([]);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const navigation = useNavigate();
  const dispatch = useDispatch();

  var res = JSON.parse(restaurant as string);
  const [queueManagementData, setQueueManagementData] = useState([]);
  const [queueManagementDataMaster, setQueueManagementDataMaster] = useState(
    [],
  );

  const getQueueMangementData = async (restaurantId) => {
    try {
      if (restaurantId) {
        await axios
          .get(
            `${process.env.REACT_APP_SECRET}/api/GetAllOrdersByRestaurantId?resId=` +
              restaurantId,
          )
          .then((res) => {
            setQueueManagementData(res.data);
            setQueueManagementDataMaster(res.data);
          })
          .catch((ex) => {
            console.log("Queue Management data Fetcing error", ex);
          });
      }
    } catch {
      alert("error fetching data in orders page");
    }
  };

  const [foodItems, setFooditems] = useState([]);

  const GetFoodItemsByRestaurantIdAndOrderId = async (
    restaurantId,
    orderId,
  ) => {
    try {
      if (restaurantId && orderId) {
        await axios
          .get(
            `${process.env.REACT_APP_SECRET}/api/GetAllFoodsByResIdNOrderId?resId=` +
              restaurantId +
              `&orderId=` +
              orderId,
          )
          .then((res) => {
            setFooditems(res.data);
          })
          .catch((ex) => {
            console.log("FoodItems fetcing error", ex);
          });
      }
      setSelectedItemId(orderId);
      setOpen(true);
    } catch {
      alert("error fetching data in orders page");
    }
  };

  //Refreshing data after status change of item
  const count = useSelector((state) => state.booleanState.value);
  useEffect(() => {
    getQueueMangementData(res.id);
    dispatch(setBooleanValue(false));
  }, [restaurant, count]);

  const [akgpageState, setakgpageState] = useState({
    isLoading: false,
    total: 0,
    page: 1,
    pageSize: 10,
  });

  const handleClose = () => {
    setOpen(false);
  };

  // const handleFilteredOrderStatus = (status: any) => {
  //   if (status === 'All') {
  //     setFilteredOrderList(OrderList);
  //   } else {
  //     const filteredOrders = OrderList.filter(
  //       (order: any) => order?.orderStatus === status
  //     );
  //     setFilteredOrderList(filteredOrders);
  //   }
  // };

  const [selectedStatus, setSelectedStatus] = useState("All");

  const statusData = [
    {
      id: 0,
      status: "All",
      backgroundColor: "rgba(30, 41, 89, 0.212)",
      textColor: "rgb(30 41 89)",
      border: "none",
      imgSrc: all,
      clickable: true,
    },
    {
      id: 1,
      status: "Queue",
      backgroundColor: "rgba(249, 138, 195, 0.302)",
      textColor: "rgb(211, 146, 17)",
      border: "none",
      imgSrc: queue,
      clickable: true,
    },
    {
      id: 2,
      status: "Pending",
      backgroundColor: "rgba(249, 197, 138, 0.302)",
      textColor: "rgb(211, 146, 17)",
      border: "none",
      imgSrc: pendingDot,
      clickable: true,
    },
    {
      id: 3,
      status: "Preparing",
      backgroundColor: "rgba(164, 208, 111, 0.364)",
      textColor: "rgb(37, 151, 65)",
      border: "none",
      imgSrc: approvegDot,
      clickable: true,
    },
    {
      id: 4,
      status: "Canceled",
      backgroundColor: "rgba(243, 138, 128, 0.266)",
      textColor: "#E30000",
      border: "none",
      imgSrc: rejectDot,
      clickable: true,
    },
    {
      id: 5,
      status: "Ready",
      backgroundColor: "rgba(157, 220, 243, 0.266)",
      textColor: "#166CBF",
      border: "none",
      imgSrc: readyDot,
      clickable: true,
    },
    {
      id: 9,
      status: "Delivered",
      backgroundColor: "rgba(164, 208, 111, 0.364)",
      textColor: "#40760E",
      border: "none",
      imgSrc: deliveredDot,
      clickable: true,
    },
  ];

  statusData.forEach((status) => {
    if (status.status === selectedStatus) {
      status.backgroundColor = status.backgroundColor.replace(
        /[^,]+(?=\))/,
        "1",
      );
      status.textColor = "rgb(0, 0, 0)";
      status.border = "1px solid black";
      if (status.status === "All") {
        status.backgroundColor = status.backgroundColor.replace(
          /[^,]+(?=\))/,
          ".61",
        );
        status.textColor = "rgb(255, 255, 255)";
        status.border = "1px solid black";
      }
    }
  });

  const Cancelationtcolumns = [
    // {
    //   field: 'itemImageUrl',
    //   headerName: 'Image',
    //   flex: 1,
    //   renderCell: (params) => (
    //     <div>
    //       <img
    //         src={params.row.itemImageUrl}
    //         style={{ width: '2rem', height: '2rem' }}
    //         alt={params.row.itemImageUrl}
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   field: "id",
    //   headerName: "OrderId",
    //   flex: 2,
    //   headerAlign: "center",
    //   align: "center",
    //   hide: true,
    //   filterable: false,
    //   renderCell: (params) => {
    //     return <span>{params.id.slice(-6)}</span>
    //   }

    // },
    {
      field: "id",
      headerName: "Order Number",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const lastSixDigits = params.id.slice(-6);
        return <span>{lastSixDigits}</span>;
      },
    },
    {
      field: "creationDate",
      headerName: "Order Time",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const orderTime = new Date(params.row.creationdate);
        const formattedTime = orderTime.toLocaleString("en-US", {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return <span>{formattedTime}</span>;
      },
    },
    {
      field: "kitchenName",
      headerName: "Kitchen Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      // renderCell: (params) => {
      //   const firstKitchenView = params.row.kitchenViews && Array.isArray(params.row.kitchenViews) ? params.row.kitchenViews[0] : null;
      //   return firstKitchenView ? <span>{firstKitchenView.kitchenName}</span> : <span>No kitchen name</span>;
      // },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      // renderCell: (params) => {
      //   const firstKitchenView = params.row.kitchenViews && Array.isArray(params.row.kitchenViews) ? params.row.kitchenViews[0] : null;
      //   return firstKitchenView ? <span>{firstKitchenView.kitchenName}</span> : <span>No kitchen name</span>;
      // },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      fieldAlign: "center",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <div className="d-flex">
            <div
              className="actionBackground"
              onClick={() =>
                GetFoodItemsByRestaurantIdAndOrderId(res.id, params.id)
              }
            >
              <p>View</p>
            </div>
          </div>
          {open && (
            <ItemsDialog
              open={open}
              handleClose={handleClose}
              orderId={selectedItemId}
              items={queueManagementData}
              queueManagementData={foodItems}
              restaurntId={res.id}
            />
          )}
        </>
      ),
      align: "center",
      headerAlign: "center",
    },
  ];

  const OrderListPage = async (props) => {
    setakgpageState((old) => ({ ...old, isLoading: true }));

    SetakgIsLoading(true);
    await axios
      .get(
        apiAddress +
          `/api/Order?restaurantId=${res.id}&pageNo=${
            props.page + 1
          }&pageSize=${props.pageSize}`,
      )
      .then((response) => {
        setakgpageState((old) => ({
          ...old,
          isLoading: false,
          total: response.data.totalCount,
          page: akgpageState.page,
        }));
        setOrderList(response.data.orderList);
        setTotal(response?.data.totalCount);
        SetakgIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        SetakgIsLoading(false);
      });
  };

  // Function to filter pending orders
  const getPendingOrders = () => {
    return OrderList.filter((order: any) => order?.orderStatus === "Pending");
  };

  // Function to filter delivered orders
  const getDeliveredOrders = () => {
    return OrderList.filter((order: any) => order?.orderStatus === "Delivered");
  };

  // Call the functions to get pending and delivered orders
  const pendingOrders = getPendingOrders();
  const deliveredOrders = getDeliveredOrders();

  const GetPurchaseOrderNoAPi = async (props) => {
    await OrderListPage(props);
  };
  //sales order table end

  const getSelectedItems = (id) => {
    setSelectedOrderIds(id);
  };

  const UpdateOrderStatus = async (statusId) => {
    var url = apiAddress + "/api/Order?statusId=" + statusId;
    await axios
      .put(url, SelectedOrderIds)
      .then((response) => {
        var props = {
          page: 0,
          pageSize: 10,
        };
        OrderListPage(props);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOrderStatus = (statusId) => {
    alert(statusId);
    UpdateOrderStatus(statusId);
  };

  // for the dropdown
  const [restaurants, setRestaurant] = React.useState([]);

  const [selectedchildRestaurant, setselectedchildRestaurant] = React.useState(
    JSON.parse(localStorage.getItem("restaurant")),
  );

  const handleRestaurantSelect = async (props) => {
    console.log(props);
    var obj = {
      id: props.id,
      name: props.name,
      ulsHLfS: props.isHomeCook,
      FMlYe6C: props.subscriptionPlanId,
    };
    localStorage.setItem("restaurant", JSON.stringify(obj));
    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    const token = localStorage.getItem("gotasteadmintoken");

    const decodedToken = jwtDecode(token);

    await unregisterPush("change", props.id);

    // await setupNotification(decodedToken.UserId, props.id);

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));
    handleClose();
  };

  const loadDataForRestaurant = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }
    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          "2e528a48-2121-48bd-97d4-b6ec8865bff2" +
          "/" +
          restaurant.id,
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        // list.push(response.data)
        // setRestaurantDatas(list);
        response.data.map((dt, i) => {
          const isHomeCook = dt.isHomeCookToggle || false;
          let fallbackPlanId = isHomeCook ? 0 : -1;

          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
            isHomeCook: dt.isHomeCookToggle || false,
            subscriptionPlanId: dt.subscriptionPlanId || fallbackPlanId,
          };
          list.push(obj);
        });

        setRestaurant(list);
      });
  };

  const [tokenData, setTokenData] = React.useState({
    UserName: "",
  });
  React.useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");

    const parentrestaurant = JSON.parse(
      localStorage.getItem("parentrestaurant"),
    );
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }
    loadDataForRestaurant();
  }, []);

  // Searching Functionality
  const [showKitchenSetup, setshowKitchenSetup] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (value) => {
    if (value !== null && value !== "") {
      setSearchTerm(value);
    } else {
      setSearchTerm("");
    }
  };

  const SearchById = (searchValue) => {
    if (searchValue !== null && searchValue !== "") {
      const searchResult = queueManagementData.filter((item) => {
        return item.id.toLowerCase().includes(searchValue.toLowerCase());
        // ||     item.toStatusData.toLowerCase().includes(searchTerm.toLowerCase());
      });
      setQueueManagementData(searchResult);
    } else {
      setQueueManagementData(queueManagementDataMaster);
    }
  };

  useEffect(() => {
    SearchById(searchTerm);
  }, [searchTerm]);

  // Filtering by Status on click
  const FilterBy = (status) => {
    setSelectedStatus(status);
    if (status !== "All") {
      const filterResult = queueManagementDataMaster.filter((item) => {
        return item.status.toLowerCase().includes(status.toLowerCase());
      });
      setQueueManagementData(filterResult);
    } else {
      setQueueManagementData(queueManagementDataMaster);
    }
  };

  const FilterByStatus = (status) => {
    switch (status) {
      case "Pending":
        FilterBy("Pending");
        break;
      case "Queue":
        FilterBy("Queue");
        break;
      case "Preparing":
        FilterBy("Preparing");
        break;
      case "Canceled":
        FilterBy("Canceled");
        break;
      case "Ready":
        FilterBy("Ready");
        break;
      case "Delivered":
        FilterBy("Delivered");
        break;
      case "All":
        FilterBy("All");
        break;
    }
  };

  return (
    <>
      <TopHeader />
      <div className="order-main-container">
        <div className="orders__side-bar">
          <div className="d-flex orders__side-bar-container">
            <div>
              <Box
                sx={{
                  maxWidth: "180px",
                  width: "13rem",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  marginLeft: ".5rem",
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {selectedchildRestaurant.name}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ marginLeft: "0px" }}
                    // value={age}
                    label="Restaurant Name"
                    // onChange={handleChange}
                  >
                    {restaurants.map((dt, i) => {
                      return (
                        <MenuItem
                          style={{ background: "none" }}
                          onClick={() => {
                            handleRestaurantSelect(dt);
                          }}
                          selected={selectedchildRestaurant.name == dt.name}
                        >
                          {dt.name}
                        </MenuItem>
                      );
                    })}

                    {/* <MenuItem value={20}>Pot Kettle Black Manchester</MenuItem> */}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>

          <div
            className={`orders__menuItem ${!showKitchenSetup ? "active" : ""}`}
            style={{
              width: "100%",
              height: "3rem",
              transition: "background-color 0.3s",
              borderRight: ".5px solid lightgray",
              cursor: "pointer",
            }}
            onClick={() => setshowKitchenSetup(false)}
          >
            <div
              className=" d-flex justify-content-start align-items-center ms-3"
              style={{ height: "100%", gap: "10px" }}
            >
              <img
                src={kitchen}
                alt="leo"
                style={{ width: "1.2rem", height: "1.2rem" }}
              />
              <p
                style={{
                  color: "black",
                  fontWeight: "500",
                  marginBottom: "0px",
                  fontSize: "13px",
                }}
              >
                Orders
              </p>
            </div>
          </div>
          {/* Orders setup buttons */}
          <div
            className={`orders__menuItem ${showKitchenSetup ? "active" : ""}`}
            style={{
              width: "100%",
              height: "3rem",
              transition: "background-color 0.3s",
              borderRight: ".5px solid lightgray",
              cursor: "pointer",
            }}
            onClick={() => setshowKitchenSetup(true)}
          >
            <div
              className=" d-flex justify-content-start align-items-center ms-3"
              style={{ height: "100%", gap: "10px" }}
            >
              <img
                src={order}
                alt="leo"
                style={{ width: "1.2rem", height: "1.2rem" }}
              />
              <p
                style={{
                  color: "black",
                  fontWeight: "500",
                  marginBottom: "0px",
                  fontSize: "13px",
                }}
              >
                Kitchen Setup
              </p>
            </div>
          </div>
        </div>
        {!showKitchenSetup ? (
          <div className="order-main-body">
            <div className="order-cart-container">
              {/* Kitchen View Added */}
              <div
                className="OrderTotalcard"
                style={{
                  backgroundColor: "#8ecae6",
                  color: "#000",
                }}
              >
                <Link to={"/orders-queue"} style={{ textDecoration: "none" }}>
                  {/* Kitchen View End */}
                  <div>
                    <p
                      className="OrderTotalNumberTitle"
                      style={{ color: "white" }}
                    >
                      Kitchen View
                    </p>
                  </div>
                </Link>
              </div>

              <div
                className="OrderTotalcard"
                style={{
                  backgroundColor: "#219ebc",
                  color: "#fff",
                }}
              >
                <div>
                  <p className="OrderTotalNumber">{total}</p>
                  <p className="OrderTotalNumberTitle ">All Orders</p>
                </div>
              </div>
              <div
                className="OrderTotalcard"
                style={{
                  backgroundColor: "#06d6a0",
                  color: "#f1f1f1",
                }}
              >
                <div>
                  <p className="OrderTotalNumber">{pendingOrders?.length}</p>
                  <p className="OrderTotalNumberTitle">Pending Orders</p>
                </div>
              </div>
              <div
                className="OrderTotalcard"
                style={{
                  backgroundColor: "#ffb703",
                  color: "#fff",
                }}
              >
                <div>
                  <p className="OrderTotalNumber">{deliveredOrders?.length}</p>
                  <p className="OrderTotalNumberTitle">Total delivered</p>
                </div>
              </div>

              {/* removed total revenue card */}
              {/* <div
                className="OrderTotalcard"
                style={{
                  backgroundColor: "#fb8500",
                  color: "#fff",
                }}
              >
                <div>
                  <p className="OrderTotalNumber">500</p>
                  <p className="OrderTotalNumberTitle">Total revenue</p>
                </div>
              </div> */}
            </div>

            <div className="d-flex gap-1 m-4 justify-content-center align-items-center">
              <div className="d-flex gap-1 m-2">
                {statusData.map((statusItem, index) => (
                  <span onClick={() => FilterByStatus(statusItem.status)}>
                    <StatusButton
                      key={index}
                      backgroundColor={statusItem.backgroundColor}
                      textColor={statusItem.textColor}
                      imgSrc={statusItem.imgSrc}
                      border={statusItem.border}
                      status={statusItem.status}
                      topButtons={true}
                      onClick={() => handleOrderStatus(statusItem.id)}
                      clickable={SelectedOrderIds?.length !== 0} // Assuming all buttons are clickable in this context
                    />
                  </span>
                ))}
              </div>

              <div className="pill-search-field">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
            <DataTableServerSidePagination
              pageState={akgpageState}
              GetDataFromAPi={GetPurchaseOrderNoAPi}
              isLoading={akgisLoading}
              rows={queueManagementData} //passing data
              columns={Cancelationtcolumns}
              getselectedData={getSelectedItems}

              // selectedRows={SelectedOrderIds} // Change this line
              // setSelectedRows={setSelectedOrderIds}
            />
          </div>
        ) : (
          <div className="kitchen-setup-page-container">
            <KitchenSetupPage />
          </div>
        )}
      </div>
    </>
  );
}

export default Orders;
